import { useEffect, useState } from "react";

import { useOrganizationContext } from "../contexts/organizations/organizationsContext";

export const useCheckAccess = (
  errorMessage: string,
  mutationError: boolean,
) => {
  const [displayError, setDisplayError] = useState("");
  const { accessAllowed } = useOrganizationContext();

  useEffect(() => {
    if (!accessAllowed) {
      setDisplayError(errorMessage);
      return;
    }
    if (mutationError) {
      setDisplayError("Something went wrong. Please try again later.");
      return;
    }
    setDisplayError("");
  }, [accessAllowed, mutationError, setDisplayError, errorMessage]);

  return { displayError };
};
